export default __webpack_public_path__ + "static/media/pen-disabled.c8a6872d.svg";